import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function loginValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value || '').trim();

    if (!value) {
      return null;
    }

    const onlyNumbers = value.replace(/\D/g, '');

    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const isCpf = onlyNumbers.length === 11;
    const isCnpj = onlyNumbers.length === 14;

    if (isEmail || isCpf || isCnpj) {
      return null;
    }

    return { loginInvalido: true };
  };
}
